<template>
    <v-container fluid>
        <v-row no-gutters>
            <v-col cols="12" sm="12" md="4" lg="4" xl="4">
                <v-toolbar-title class="ml-2 mt-2">{{titulo}}</v-toolbar-title>
            </v-col>
            <v-col cols="12" sm="12" md="8" lg="8" xl="8" align="end">   
                <v-btn
                    v-if="tipo=='configuracao'"
                    class="ml-2 my-1"
                    color="primary"
                    @click="novo()"
                >
                    <v-icon left>mdi-plus</v-icon> Criar
                </v-btn>
                <!-- <v-btn
                    class="ml-2 my-1"
                    color="primary" 
                    @click="exportarHistorico({})"
                >
                    <v-icon left>mdi-microsoft-excel</v-icon> Exportar Histórico
                </v-btn> -->
            </v-col>
        </v-row>
        <v-card class="mt-2 py-4 px-2" elevation="1">  
            <v-row no-gutters class="mb-4">
                <v-col cols="12" sm="12" md="4" lg="4" xl="4">
                    <v-select
                        label="Ativos"
                        :items="[{text:'Sim', value: 1},{text:'Não', value: 0},{text:'Todos', value: null}]"
                        v-model="ativo"
                        dense 
                        outlined
                        hide-details
                    >
                    </v-select>
                </v-col>
                <v-col cols="12" sm="12" md="4" lg="4" xl="4">
                </v-col>
                <v-col cols="12" sm="12" md="4" lg="4" xl="4" align="end">
                    <v-text-field
                        v-model="busca"
                        append-icon="mdi-magnify"
                        label="Pesquisar"
                        dense 
                        outlined
                        hide-details
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-data-table
                :headers="headers"
                :items="dados"
                :items-per-page="5"
                :footer-props="{
                    'items-per-page-options': [5, 10, 15, 25, 50, 100]
                }"
                :options.sync="pagination"
                multi-sort
                class="elevation-0"
            >   
                <template v-slot:[`item.botao`]="{ item }"> 
                    <v-icon
                        v-if="tipo=='configuracao'"
                        small
                        color="primary"
                        @click="editar(item)"
                        title="Editar"
                    >
                        mdi-pencil
                    </v-icon>
                    <v-icon
                        small
                        class="ml-6"
                        color="primary"
                        @click="exportar(item)"
                        title="Exportar"
                        :disabled="item.cargos < 2"
                    >
                        mdi-microsoft-excel
                    </v-icon>
                    <v-icon
                        small
                        class="ml-6"
                        color="primary"   
                        @click="abrirImportar(item)"
                        title="Importar Setores"
                        :disabled="item.cargos < 2"
                    >
                        mdi-upload
                    </v-icon>
                    <v-icon
                        small
                        class="ml-6"
                        color="primary"
                        @click="limparConfirm(item)"
                        title="Limpar Setores"
                        :disabled="item.setores == 0"
                    >
                        mdi-trash-can
                    </v-icon>
                </template>
                <template v-slot:[`item.historico`]="{ item }">
                    <v-icon
                        small
                        class="mr-2"
                        color="primary"
                        @click="buscaHistorico(item)"
                        title="Histórico"
                    >
                        mdi-file-document-multiple
                    </v-icon>
                </template>
            </v-data-table>
        </v-card>

        <v-dialog
            v-model="dialogo"
            width="90%"
        >  
            <v-card>
                <v-card-title class="subtitle-1 primary white--text">
                    {{tituloDialogo}}
                </v-card-title>
                <v-card-text class="mt-4">
                    <v-form ref="form">
                        <v-row no-gutters class="mt-4">
                            <v-col cols="12" sm="12" md="6" lg="6" xl="4" class="px-2"> 
                                <v-text-field
                                    outlined
                                    dense 
                                    disabled
                                    :label="'ID '+tituloDialogo"
                                    v-model="obj['id_'+tabela]"
                                ></v-text-field> 
                            </v-col>
                            <v-col cols="12" sm="12" md="6" lg="6" xl="4" class="px-2"> 
                                <v-text-field
                                    outlined
                                    dense 
                                    :label="tituloDialogo"
                                    v-model="obj.nome"
                                    :rules="regra.nome"
                                ></v-text-field> 
                            </v-col>
                        </v-row>
                        <v-col cols="12" sm="12" md="4" lg="4" xl="3" class="px-2"> 
                            <v-select
                                label="Ativo"
                                :items="[{text:'Sim', value: 1},{text:'Não', value: 0}]"
                                v-model="obj.ativo"
                                outlined
                                dense 
                            >
                            </v-select> 
                        </v-col>
                        <v-row no-gutters class="mb-2">
                            <v-col cols="12" sm="12" md="12" lg="12" xl="12" align="end">
                                <v-btn
                                    color="primary"
                                    class="pr-4"
                                    @click="dialogoAdicionar=true"
                                    v-show="obj.id_hierarquia"
                                    :disabled="obj.setores > 0"
                                >
                                    <v-icon left>mdi-plus</v-icon> Adicionar Cargo
                                </v-btn> 
                            </v-col>
                        </v-row>
                        <v-data-table
                            :headers="headerCargo"
                            :items="hierarquiaCargo"
                            :items-per-page="5"
                            :footer-props="{
                                'items-per-page-options': [5, 10, 15, 25, 50, 100]
                            }"
                            :options.sync="paginationCargo" 
                            class="elevation-0"
                            v-show="obj.id_hierarquia"
                        >   
                            <template v-slot:[`item.botao`]="{ item }"> 
                                <v-icon
                                    small
                                    class="mr-2"
                                    color="primary"
                                    @click="removerCargo(item)"
                                    title="Remover Cargo"
                                    :disabled="obj.setores > 0"
                                >
                                    mdi-trash-can
                                </v-icon>
                            </template>
                        </v-data-table>
                    </v-form>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        class="pr-4"
                        @click="dialogo = false"
                    >
                        <v-icon left>mdi-close</v-icon> Fechar
                    </v-btn>
                    <v-btn
                        color="primary"
                        class="pr-4"
                        @click="salvar()"
                    >
                        <v-icon left>mdi-content-save</v-icon> Salvar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="dialogoAdicionar"
            width="600"
        >  
            <v-card>
                <v-card-title class="subtitle-1 primary white--text">
                    Adicionar Cargo
                </v-card-title>
                <v-card-text class="mt-4"> 
                    <v-autocomplete
                        label="Cargo"
                        :items="cargosDisponiveis"
                        v-model="id_cargo"
                        clearable
                        outlined
                        dense 
                    >
                    </v-autocomplete>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        class="pr-4"
                        @click="dialogoAdicionar=false"
                    >
                        <v-icon left>mdi-close</v-icon> Fechar
                    </v-btn>
                    <v-btn
                        color="primary"
                        class="pr-4"
                        @click="adicionarCargo()"
                    >
                        <v-icon left>mdi-content-save</v-icon> Adicionar Cargo
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="dialogoLimpar"
            width="600"
        >  
            <v-card>
                <v-card-title class="subtitle-1 primary white--text">
                    Limpar Setores
                </v-card-title>
                <v-card-text class="mt-4"> 
                    Deseja realmente remover todos os setores da hierarquia?
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        class="pr-4"
                        @click="dialogoLimpar=false"
                    >
                        <v-icon left>mdi-close</v-icon> Fechar
                    </v-btn>
                    <v-btn
                        color="error"
                        class="pr-4"
                        @click="limpar()"
                    >
                        <v-icon left>mdi-close</v-icon> Limpar Setores
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="dialogoImportar"
            width="90%"
        >  
            <v-card>
                <v-card-title class="subtitle-1 primary white--text">
                    Importar CSV
                </v-card-title>
                <v-card-text>
                    <v-alert
                        class="mt-4"
                        text
                        type="info"
                        border="left"
                        style="font-size: 12px;"
                    >
                        <ul>
                            <li>
                                Os nomes das colunas devem ser <b>idênticos</b> aos da base exportada.
                            </li>
                            <li>
                                Todas as colunas são obrigatórias.
                            </li>
                            <li>
                                Cada setor só pode ter um setor pai. No caso de um setor ser importados com setores pais diferentes o ultimo setor pai sobrescrevera os anteriores.
                            </li>
                        </ul> 
                    </v-alert> 
                    <v-row no-gutters>  
                        <v-col cols="8" class="px-2">
                            <v-form ref="form" v-model="isCsv">
                                <v-file-input 
                                    label="Arquivo CSV" 
                                    outlined 
                                    dense
                                    v-model="arquivoCSV"
                                    :rules="regra.csv"
                                    accept=".csv"
                                ></v-file-input>
                            </v-form>
                        </v-col> 
                        <v-col cols="4" class="px-2">
                            <v-btn
                                color="primary"
                                :disabled="!isCsv"
                                @click="importar()"
                            >
                                <v-icon left>mdi-upload</v-icon> 
                                Importar Arquivo
                            </v-btn>
                        </v-col> 
                    </v-row> 
                    <v-expand-transition>
                        <div v-show="erro">
                            <v-row no-gutters class="mb-0">
                                <v-col cols="6">
                                    <download-csv
                                        :data="erros"
                                        :labels="errosLabels"
                                        name= "erros.csv"
                                        delimiter=";"
                                    >
                                        <v-btn color="primary">
                                            <v-icon left>mdi-microsoft-excel</v-icon>
                                            Exportar Logs
                                        </v-btn>
                                    </download-csv>
                                </v-col>
                            </v-row> 
                            <v-data-table
                                :headers="headerErros"
                                :items="erros"
                                :items-per-page="5"
                                :options.sync="paginationErros" 
                                class="elevation-0 data-table-2"
                            ></v-data-table>
                        </div>
                    </v-expand-transition>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        class="pr-4"
                        @click="dialogoImportar=false"
                    >
                        <v-icon left>mdi-close</v-icon> Fechar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="historico.dialogo"
            width="90%"
        >  
            <v-card>
                <v-card-title class="subtitle-1 primary white--text">
                    Histórico
                </v-card-title>
                <v-card-text>
                    <v-row no-gutters class="mt-2 mb-2">
                        <v-col cols="6">
                        </v-col>
                        <v-col cols="6" align="end">  
                            <!-- <v-btn
                                class="ml-2"
                                color="primary" 
                                @click="exportarHistorico({fnId: true})"  
                            >
                                <v-icon left>mdi-microsoft-excel</v-icon> Exportar CSV
                            </v-btn> -->
                        </v-col>
                    </v-row>
                    <v-data-table
                        :headers="historico.headers"
                        :items="historico.dados"
                        :items-per-page="5"
                        :footer-props="{
                            'items-per-page-options': [5, 10, 15, 25, 50, 100]
                        }"
                        class="elevation-0"
                    >
                        <template v-slot:[`item.arquivo`]="{ item }">
                            <v-icon
                                v-if="item.arquivo"
                                small
                                class="mr-2"
                                color="primary"
                                @click="arquivo(item)"
                                title="Arquivo Importado"
                            >
                                mdi-microsoft-excel
                            </v-icon>
                        </template>
                    </v-data-table>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        class="pr-4"
                        @click="historico.dialogo = false"
                    >
                        <v-icon left>mdi-close</v-icon> Fechar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-overlay :value="carregando" :z-index="300">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        
        <v-snackbar
            v-model="alerta"
            :color="alertaColor"
            :timeout="alertaTimeout"
            top
            style="z-index: 400"
        >
            <v-alert :type="alertaColor">
                {{ alertaTexto }}
            </v-alert>
            <v-btn
                dark
                text
                class="float-right"
                @click="alerta=false"
            >
            Fechar
            </v-btn>
        </v-snackbar>

    </v-container>
</template>

<script>

export default {
    data() {
        return {
            tabela: 'hierarquia',
            tipo: 'importacao',
            titulo: 'Hierarquias',
            tituloDialogo: 'Hierarquia',
            headers: [
                { text: '', value: 'historico', align: 'center', sortable: false },
                { text: 'ID Hierarquia', value: 'id_hierarquia', align: 'center'},
                { text: 'Hierarquia', value: 'nome', align: 'center'},
                { text: 'Ativo', value: 'ativo_nome', align: 'center'},
                { text: 'Cargos', value: 'cargos', align: 'center'},
                { text: 'Setores', value: 'setores', align: 'center'},
                { text: '', value: 'botao', align: 'center', sortable: false },
            ],
            dados: [], 
            obj: {
                id_Hierarquia: null,
                nome: null,
                ativo: 1,
            },
            pagination: {}, 
            paginationCargo: {}, 
            paginationErros: {}, 
            carregando: false, 
            ativo: 1, 
            busca: null, 
            dialogo: false,
            dialogoAdicionar: false,
            dialogoImportar: false,
            dialogoLimpar: false,
            validaForm: false,
            alerta: false,
            alertaTexto: '',
            alertaColor: 'error',
            alertaTimeout: 3000,
            arquivoCSV: null,
            regra: { 
                nome: [v => !!v || 'Campo obrigatório.'],
                csv: [
                    v => !!v || 'Selecione um arquivo.',
                    v => (!!v && [
                        '.csv', 
                        '.CSV'
                    ].includes(v.name.substr(-4))) || 'O arquivo deve ser do tipo CSV.',
                ] ,
            },  
            isCsv: false,
            headerErros: [
                { text: 'Descrição', value: 'msg', align: 'left'},
            ],
            erros: [],
            errosLabels: {msg: 'Descrição'}, 
            erro: false,
            headerCargo: [
                { text: 'ID Cargo', value: 'id_cargo', align: 'center', sortable: false },
                { text: 'Cargo', value: 'cargo', align: 'center', sortable: false },
                { text: 'Ordem', value: 'ordem', align: 'center', sortable: false },
                { text: 'Superior', value: 'cargo_pai', align: 'center', sortable: false },
                { text: '', value: 'botao', align: 'center', sortable: false },
            ],
            hierarquiaCargo: [],
            cargosDisponiveis: [],
            cargos: [],
            id_cargo: null,
            historico: {
                headers: [
                    { text: 'Responsável', value: 'usuario_atualizacao', align: 'center'},
                    { text: 'Data', value: 'data', align: 'center'},
                    { text: 'ID Hierarquia', value: 'id_hierarquia', align: 'center'},
                    { text: 'Hierarquia', value: 'hierarquia', align: 'center'},
                    { text: 'Tipo', value: 'tipo', align: 'center'},
                    { text: 'Arquivo', value: 'arquivo', align: 'center'},
                ],
                dados: [],
                dialogo: false,
                item: {}
            },
        }
    },
    watch: {
        ativo() {

            this.filtrar()
        },
        '$route' () {

            this.tipo = this.$route.params.tipo

            this.filtrar()
        }
    },
    async created() {

        this.tipo = this.$route.params.tipo

        this.filtrar()
    },
    methods: {
        async filtrar() {

            this.carregando = true

            var response = await this.$http().post(`/cargo/filtro`, {}) 

            this.cargos = response.data

            var data = {}
            data.filtro = {}
            data.filtro.ativo = this.ativo == null ? [] : [this.ativo]

            response = await this.$http().post(`/${this.tabela}/lista`, {data: data})
            
            this.dados = response.data
            
            this.carregando = false
        },
        async exportar(item) {
           
            this.carregando = true
            
            var data = {id_hierarquia: item.id_hierarquia}

            var response = await this.$http().post(`/${this.tabela}/exportar`, {data: data})   
          
            window.location = this.$http('baseURL')+response.data.url
            
            this.carregando = false
        },
        novo() {
           
            this.obj = {
                id_Hierarquia: null,
                nome: null,
                ativo: 1,
            }

            try {
                this.$refs.form.resetValidation()
            } catch (error) {
                //console.log(error)
            }  

            this.hierarquiaCargo = []

            this.cargosDisponiveis = this.cargos.filter(c => !this.hierarquiaCargo.map(hc => hc.id_cargo).includes(c.value))
            
            this.dialogo = true
        }, 
        editar(item) {
           
            this.obj = {...item}

            try {
                this.$refs.form.resetValidation()
            } catch (error) {
                //console.log(error)
            }  

            this.hierarquiaCargo = []
            
            this.dialogo = true
            
            this.buscarCargo(item)
        }, 
        async buscarCargo(item) {

            this.carregando = true

            var data = {id_hierarquia: item.id_hierarquia}

            var response = await this.$http().post(`/${this.tabela}/hierarquiaCargo`, {data: data})  

            this.hierarquiaCargo = response.data

            this.cargosDisponiveis = this.cargos.filter(c => !this.hierarquiaCargo.map(hc => hc.id_cargo).includes(c.value))
            
            this.carregando = false
        }, 
        async salvar() {

            for (const key in this.obj) {

                if (typeof this.obj[key] == 'string') {

                    this.obj[key] = this.obj[key].trim()
                }
            }
            
            if(!this.$refs.form.validate()) return
            
            this.carregando = true
            
            var data = this.obj

            var response = await this.$http().post(`/${this.tabela}/salvar`, {data: data})   
            
            this.carregando = false

            if(response.data.sucesso){

                this.filtrar()
                this.dialogo = false  
            }
            else{

                this.alerta = true
                this.alertaColor = 'error'
                this.alertaTimeout = -1
                this.alertaTexto = response.data.msg
            }  
        }, 
        async removerCargo(item) {
            
            this.carregando = true

            var data = {
                id_hierarquia: this.obj.id_hierarquia,
                id_cargo: item.id_cargo
            }

            var response = await this.$http().post(`/${this.tabela}/removerCargo`, {data: data})  
            
            this.carregando = false

            if(response.data.sucesso){

                this.alerta = true
                this.alertaColor = 'success'
                this.alertaTimeout = 1000
                this.alertaTexto = response.data.msg  
            }
            else{

                this.alerta = true
                this.alertaColor = 'error'
                this.alertaTimeout = -1
                this.alertaTexto = response.data.msg
            } 
            
            this.buscarCargo(this.obj)

            this.filtrar()
        }, 
        async adicionarCargo() {
            
            this.carregando = true

            var data = {
                id_hierarquia: this.obj.id_hierarquia,
                id_cargo: this.id_cargo
            }

            var response = await this.$http().post(`/${this.tabela}/adicionarCargo`, {data: data})  
            
            this.carregando = false
            this.dialogoAdicionar = false

            if(response.data.sucesso){

                this.alerta = true
                this.alertaColor = 'success'
                this.alertaTimeout = 1000
                this.alertaTexto = response.data.msg  
            }
            else{

                this.alerta = true
                this.alertaColor = 'error'
                this.alertaTimeout = -1
                this.alertaTexto = response.data.msg
            } 

            this.buscarCargo(this.obj)

            this.filtrar()
        }, 
        abrirImportar(item) {

            this.obj = {...item}

            this.arquivoCSV = null
            this.erro = false

            try {
                this.$refs.form.resetValidation()
            } catch (error) {
                //console.log(error)
            }  

            this.dialogoImportar = true 
        },
        async importar() {

            this.carregando = true
            
            var formData = new FormData()

            formData.append("files", this.arquivoCSV)
            formData.append("data", JSON.stringify({id_hierarquia: this.obj.id_hierarquia}))

            this.arquivoCSV = null

            try {
                this.$refs.form.resetValidation()
            } catch (error) {
                //console.log(error)
            }

            var response = await this.$http().post(`/${this.tabela}/importar`, formData)  

            this.carregando = false

            if(response.data.sucesso){

                this.filtrar()
                this.dialogoImportar = false
            }
            else{

                this.filtrar()
                this.erros = response.data.erros
                this.pagination.page = 1
                this.erro = true
            }  
        },
        async limparConfirm(item) {

            this.obj = item

            this.dialogoLimpar = true
        }, 
        async limpar() {

            this.carregando = true

            var data = {id_hierarquia: this.obj.id_hierarquia}

            var response = await this.$http().post(`/${this.tabela}/limpar`, {data: data})  

            this.carregando = false
            this.dialogoLimpar = false 

            if(response.data.sucesso){

                this.alerta = true
                this.alertaColor = 'success'
                this.alertaTimeout = 1000
                this.alertaTexto = response.data.msg 
            }
            else{

                this.alerta = true
                this.alertaColor = 'error'
                this.alertaTimeout = -1
                this.alertaTexto = response.data.msg
            } 

            this.filtrar()
        },
        async buscaHistorico(item) {

            this.carregando = true

            this.historico.item = {...item}
            
            var data = {
                tabela: this.tabela,
                id: item['id_'+this.tabela],
            }

            var response = await this.$http().post(`/historico/lista`, {data: data})
            
            this.historico.dados = response.data
            
            this.carregando = false

            this.historico.dialogo = true
        },
        async exportarHistorico({fnId=false}) {

            this.carregando = true

            var data = {
                tabela: this.tabela,
                id: fnId ? this.historico.item['id_'+this.tabela] : false,
            }

            var response = await this.$http().post(`/historico/exportar`, {data: data})
            
            window.location = this.$http('baseURL')+response.data.url
            
            this.carregando = false
        },
        arquivo(item) {

            window.location = item.arquivo
        },
    },
}
</script>